import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Modal child styles
  subText: {
    display: 'block',
    textAlign: 'center',
    maxWidth: '85%',
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  content: {
    padding: '0 2rem',
    [theme.breakpoints.down('xs')]: {
      padding: '0 8px',
    },
  },
}));

export default useStyles;
